

























































import { mapGetters } from 'vuex';
import { DataTableHeader } from 'vuetify';

import {
  deleteAutoclickerGame,
  getAutoclickerGames
} from '@/api/CopyStake/AutoClicker';
import { TAutoclickerGameData } from '@/api/schema';
import { AxiosError } from 'axios';
import { errorToastMessage } from '@/helpers/errorToastMessage';

const ConfirmationDialog = (): Promise<any> =>
  import('@/components/ConfirmationDialog.vue');
const CopyStakeAutoclickerGameDialog = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeAutoclicker/GamesForAutoclicker/CopyStakeAutoclickerGameDialog.vue'
  );

const DEFAULT_PAGINATION_OPTIONS: { page: number; itemsPerPage: number } = {
  page: 1,
  itemsPerPage: 10
};

export default {
  name: 'CopyStakeGamesForAutoclickerTab',
  components: {
    CopyStakeAutoclickerGameDialog,
    ConfirmationDialog
  },
  data(): any {
    return {
      autoclickerGamesList: [] as TAutoclickerGameData[],
      tableOptions: { ...DEFAULT_PAGINATION_OPTIONS },

      editableGame: null as TAutoclickerGameData | null,
      showGameModal: false,
      showConfirmModal: false,
      confirmModalPayload: {},

      loading: {
        gamesList: false,
        deleteGame: false
      },

      dialogs: {
        copyStakeAutoclickerGameDialog: false,
        gameData: null,
        confirmationDialog: false,
        confirmationData: null,
        isLoading: false
      }
    };
  },
  watch: {
    operatorId: {
      handler(): void {
        if (this.operatorId !== null) {
          this.getAutoclickerGamesList();
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),
    isLoading(): boolean {
      return Object.values(this.loading).some(Boolean);
    },
    headers(): DataTableHeader[] {
      return [
        { text: 'Game Name', value: 'gameName' },
        { text: 'Provider', value: 'provider' },
        { text: 'Game Url', value: 'gameUrl' },
        { text: 'Action', value: 'actions', width: 160 }
      ];
    }
  },
  methods: {
    async getAutoclickerGamesList(): Promise<void> {
      this.loading.gamesList = true;

      getAutoclickerGames()
        .then((data: TAutoclickerGameData[]) => {
          this.autoclickerGamesList = data;
        })
        .catch((error: AxiosError) => {
          errorToastMessage(error);
          this.autoclickerGamesList = [];
        })
        .finally(() => {
          this.loading.gamesList = false;
        });
    },
    async removeAutoclickerGame(
      gameData: TAutoclickerGameData
    ): Promise<void> {
      this.loading.deleteGame = true;

      deleteAutoclickerGame(gameData.id)
        .then(() => {
          this.$toast.success(
            `Game "${gameData.gameName} [${gameData.provider}]" was successfully deleted`
          );

          this.getAutoclickerGamesList();
          this.dialogs.confirmationDialog = false;
        })
        .catch((error) => {
          errorToastMessage(error);
        })
        .finally(() => {
          this.loading.deleteGame = false;
        });
    },

    openCreateEditGameDialog(gameData: TAutoclickerGameData = null): void {
      this.dialogs.copyStakeAutoclickerGameDialog = true;

      this.dialogs.gameData = gameData;
    },
    openRemoveGameConfirmationDialog(gameData: TAutoclickerGameData): void {
      this.dialogs.confirmationData = {
        disclaimer: `<p>
            Are you sure you want to delete <strong>${gameData.gameName} [${gameData.provider}]</strong> game?
          </p>`,
        header: 'Delete Game',
        okText: 'Delete',
        handler: () => this.removeAutoclickerGame(gameData)
      };

      this.dialogs.confirmationDialog = true;
    },

    handlerClickCreateEditGameBtn(
      gameData: TAutoclickerGameData = null
    ): void {
      this.openCreateEditGameDialog(gameData);
    },
    handlerClickRemoveGameBtn(gameData: TAutoclickerGameData): void {
      this.openRemoveGameConfirmationDialog(gameData);
    },
    handlerSubmitEventGameDialog(): void {
      this.getAutoclickerGamesList();
    },
    handlerCloseEventGameDialog(): void {
      this.dialogs.copyStakeAutoclickerGameDialog = false;

      this.dialogs.gameData = null;
    },
    handlerCloseEventConfirmationDialog(): void {
      this.dialogs.confirmationDialog = false;

      this.dialogs.confirmationData = null;
    }
  }
};
